'use client';

import type { ChangeEvent } from 'react';

export interface DropdownProps {
  id: string;
  value: string;
  label?: string;
  options: { label: string; value: string }[];
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function Dropdown({ id, value, label, options, onChange, disabled }: DropdownProps) {
  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value);
  };

  return (
    <div>
      {label && (
        <label className="mb-1 block text-foreground" htmlFor={id}>
          {label}
        </label>
      )}
      <select
        className="w-full rounded-[.125rem] border border-[var(--content-neutral-darker)] px-4 py-2 hover:bg-muted focus:border-[var(--content-blue-light)] focus:bg-[var(--content-blue-lightest)] focus:shadow-[0_0_0_.05rem_var(--content-blue-light)] focus:outline-none sm:w-auto"
        disabled={disabled}
        id={id}
        name="dropdown"
        onChange={handleChange}
        value={value}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
